/*global BASE_URL, console, _, Modernizr*/
/*jshint browser:true, jquery:true, undef:true, multistr: true*/
$( document ).ready(function() {
    
    var browserWindow = $( this );

    // [twbs-pagination] ::start
    (function() {

        var paginationTarget = $( '.pagination' );

        if ( paginationTarget.length > 0 ) {

            paginationTarget.each( function () {
                var _this = $( this );

                var paginationOptions = {
                    totalPages: _this.data( 'total-pages' ),
                    visiblePages: _this.data( 'visible-pages' ),
                    startPage: _this.data( 'start-page' ),
                    initiateStartPageClick: false,
                    onPageClick: function (event, page) {
                        var _newUrl = _this.data( 'base-url' ) + '/' + page;
                        window.location = _newUrl;
                    },
                    first: '&laquo;',
                    last: '&raquo;'
                };

                // Store original pagination options
                _this.data( '_options', paginationOptions );

                _this.twbsPagination( paginationOptions );
            });

            $( window ).on( 'resize.twbs', _.debounce(function () {
                paginationTarget.each( function () {
                    var _this       = $( this ),
                        _newOptions = {};

                    _newOptions = _this.data( '_options' );

                    // Destroy then re-draw the pagination
                    _this.twbsPagination( 'destroy' );

                    if ( browserWindow.width() < 992 ) {
                        _newOptions.visiblePages = 3;
                    } else {
                        _newOptions.visiblePages = 5;
                    }

                    _this.twbsPagination( _newOptions );

                });
            }, 300) );

            $( window ).trigger( 'resize.twbs' );

        }

    })();
    // [twbs-pagination] ::end

});
